import { checkLiveMatches } from "../modules/helpers";

/* function to load winners
**************************************************************/
function loadWinners(container) {
  let tournament_id = container.getAttribute('data-tournament');
  let substage_btn = document.querySelector('[data-phase="final"]');
  let substage_ids = substage_btn ? substage_btn.getAttribute('data-substage') : '';

	$.ajax({
		type: "POST",
		url: themeVars.adminUrl,
		data: {
      action: "tournament_winners",
      substage_ids: substage_ids,
      tournament_id: tournament_id,
		},
		beforeSend: function() {
		},
		success: function(response) {
      winnersRendering(response);
		},
	});
}

/* create winners field
**************************************************************/
function winnersRendering(json) {
  let container = document.querySelector('.tournament-block__places');
  let logos = document.querySelectorAll('.tournament-block__places-logo');
  let names = document.querySelectorAll('.tournament-block__places-team');

  if(json[0] && json[1] && json[2]) {
    for(let i = 0; i < logos.length; i++) {
      logos[i].style.backgroundImage = `url(${json[i].logo})`;
      names[i].innerText  += json[i].name;
    }
    container.style.height = 'auto';
    container.style.opacity = '1';
  } else {
    container.remove();
  }
}


/* first load
**************************************************************/
document.addEventListener("DOMContentLoaded", function() {
  loadWinners(document.querySelector('.tournament-block'));
  checkLiveMatches(document.querySelector('.tournament-block'));
});

export {
  checkLiveMatches,
};



// WEBPACK FOOTER //
// ./scripts/layouts/tournaments-page.js